"use strict";
// tslint:disable
// eslint-disable
/**
 * HEM Workbench API Specification
 * Health Economics Workbench API Specification
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportApi = void 0;
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 * no description
 */
class ReportApi extends runtime.BaseAPI {
    /**
     * Manage incident raised
     */
    createIncidentRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.incidentDTO === null || requestParameters.incidentDTO === undefined)) {
                throw new runtime.RequiredError('incidentDTO', 'Required parameter requestParameters.incidentDTO was null or undefined when calling createIncident.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/report`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.IncidentDTOToJSON(requestParameters.incidentDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IncidentDetailDTOFromJSON(jsonValue));
        });
    }
    /**
     * Manage incident raised
     */
    createIncident(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createIncidentRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get incident with provided incidentId
     */
    getIncidentRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.incidentId === null || requestParameters.incidentId === undefined)) {
                throw new runtime.RequiredError('incidentId', 'Required parameter requestParameters.incidentId was null or undefined when calling getIncident.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/report/{incidentId}`.replace(`{${"incidentId"}}`, encodeURIComponent(String(requestParameters.incidentId))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IncidentListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Get incident with provided incidentId
     */
    getIncident(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIncidentRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * List all incidents
     */
    getIncidentListRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/report`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(models_1.IncidentListDTOFromJSON));
        });
    }
    /**
     * List all incidents
     */
    getIncidentList() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getIncidentListRaw();
            return yield response.value();
        });
    }
    /**
     * Update incident status
     */
    updateIncidentRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV === "development" && (requestParameters.incidentId === null || requestParameters.incidentId === undefined)) {
                throw new runtime.RequiredError('incidentId', 'Required parameter requestParameters.incidentId was null or undefined when calling updateIncident.');
            }
            if (process.env.NODE_ENV === "development" && (requestParameters.incidentDTO === null || requestParameters.incidentDTO === undefined)) {
                throw new runtime.RequiredError('incidentDTO', 'Required parameter requestParameters.incidentDTO was null or undefined when calling updateIncident.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/report/{incidentId}`.replace(`{${"incidentId"}}`, encodeURIComponent(String(requestParameters.incidentId))),
                method: 'PATCH',
                headers: headerParameters,
                query: queryParameters,
                body: models_1.IncidentDTOToJSON(requestParameters.incidentDTO),
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.IncidentListDTOFromJSON(jsonValue));
        });
    }
    /**
     * Update incident status
     */
    updateIncident(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateIncidentRaw(requestParameters);
            return yield response.value();
        });
    }
}
exports.ReportApi = ReportApi;
